(() => {
  const init = () => {
    const videos = [...document.querySelectorAll('video[data-ocb-defer]')];
    const observedChatRoots = new WeakSet();
    let chatMutationFrame;
    const mobileChatStyle = '@media(max-width:749px){.activator-nudge{right:12px!important;bottom:max(10px,env(safe-area-inset-bottom))!important;width:46px!important;height:46px!important}.activator{width:46px!important;min-width:46px!important;height:46px!important;padding:0!important;border-radius:999px!important}.activator__label{display:none!important}.activator__icon{margin:auto!important}}';

    const observeChatRoot = (root) => {
      if (!root || observedChatRoots.has(root)) return;
      observedChatRoots.add(root);
      new MutationObserver(() => {
        if (chatMutationFrame) return;
        chatMutationFrame = window.requestAnimationFrame(() => {
          chatMutationFrame = undefined;
          compactMobileChat();
        });
      }).observe(root, { childList: true, subtree: true });
    };

    const compactMobileChat = () => {
      const chat = document.querySelector('shopify-chat');
      if (!chat) return false;

      const visit = (root) => {
        if (!root) return false;
        const launcher = root.querySelector('.activator-nudge');
        if (launcher) {
          const button = root.querySelector('.activator');
          const label = root.querySelector('.activator__label');
          const icon = root.querySelector('.activator__icon');
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          let style = root.getElementById?.('ocb-mobile-chat-style');
          if (!style) {
            style = document.createElement('style');
            style.id = 'ocb-mobile-chat-style';
            root.appendChild(style);
          }
          if (style.textContent !== mobileChatStyle) style.textContent = mobileChatStyle;
          observeChatRoot(root);

          if (isMobile) {
            launcher.style.setProperty('right', '12px', 'important');
            launcher.style.setProperty('bottom', 'max(10px, env(safe-area-inset-bottom))', 'important');
            launcher.style.setProperty('width', '46px', 'important');
            launcher.style.setProperty('height', '46px', 'important');
            button?.style.setProperty('width', '46px', 'important');
            button?.style.setProperty('min-width', '46px', 'important');
            button?.style.setProperty('height', '46px', 'important');
            button?.style.setProperty('padding', '0', 'important');
            button?.style.setProperty('border-radius', '999px', 'important');
            label?.style.setProperty('display', 'none', 'important');
            icon?.style.setProperty('margin', 'auto', 'important');
          } else {
            ['right', 'bottom', 'width', 'height'].forEach((property) => launcher.style.removeProperty(property));
            ['width', 'min-width', 'height', 'padding', 'border-radius'].forEach((property) => button?.style.removeProperty(property));
            label?.style.removeProperty('display');
            icon?.style.removeProperty('margin');
          }
          return true;
        }
        return [...root.querySelectorAll('*')].some((node) => node.shadowRoot && visit(node.shadowRoot));
      };

      return visit(chat.shadowRoot);
    };

    let chatTimer;
    let chatHostObserver;
    let chatAttempts = 0;
    const stopChatTimer = () => {
      if (chatTimer) window.clearInterval(chatTimer);
      chatTimer = undefined;
    };
    const startMobileChatCheck = () => {
      if (!window.matchMedia('(max-width: 749px)').matches || chatTimer || !document.querySelector('shopify-chat')) return;
      chatAttempts = 0;
      if (compactMobileChat()) return;
      chatTimer = window.setInterval(() => {
        chatAttempts += 1;
        if (!window.matchMedia('(max-width: 749px)').matches || compactMobileChat() || chatAttempts >= 16) stopChatTimer();
      }, 750);
    };
    const observeMobileChatHost = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (document.querySelector('shopify-chat')) {
        startMobileChatCheck();
        return;
      }
      if (chatHostObserver) return;
      chatHostObserver = new MutationObserver(() => {
        if (!document.querySelector('shopify-chat')) return;
        chatHostObserver.disconnect();
        chatHostObserver = undefined;
        startMobileChatCheck();
      });
      chatHostObserver.observe(document.documentElement, { childList: true, subtree: true });
    };
    const scheduleMobileChatCheck = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(observeMobileChatHost, { timeout: 2000 });
      } else {
        window.setTimeout(observeMobileChatHost, 1200);
      }
    };
    let resizeFrame;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = undefined;
        if (window.matchMedia('(max-width: 749px)').matches) scheduleMobileChatCheck();
        else {
          stopChatTimer();
          compactMobileChat();
        }
      });
    }, { passive: true });
    scheduleMobileChatCheck();

    if (!videos.length) return;

    const loadVideo = (video) => {
      if (video.dataset.ocbLoaded) return;
      if (video.dataset.poster) video.poster = video.dataset.poster;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.dataset.ocbLoaded = 'true';
      video.load();
    };

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '120px 0px' });

    videos.forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
